import React, { useRef } from 'react'
import { MapContainer,Marker,Popup,TileLayer } from 'react-leaflet'
import l from 'leaflet'
import 'leaflet/dist/leaflet.css'
const KnustMap = () => {
    const ref=useRef()
    const maker=new l.icon({
        iconUrl:'https://unpkg.com/leaflet@1.6.0/dist/images/marker-icon-2x.png',
        iconSize:[25,35],
        popupAnchor:[7,7],
       iconAnchor:[3,-7]
    })
  return (
    <div>
       <MapContainer center={[5.5648938,-0.1857726]} zoom={13} ref={ref}>
        <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' />
        <Marker position={[5.5680038,-0.1864105]} icon={maker}>
            <Popup>
                <h3>KNUST GuestHoues</h3>
            </Popup>
        </Marker>
      </MapContainer>
    </div>
  )
}

export default KnustMap